import { css } from '@emotion/css'
import { ToggleButton } from 'components/ToggleButton/ToggleButton'
import { translate } from 'i18n/i18n'
import type { TChillMarVsMay, TChillSepVsNov } from 'stores/detailsPanelStore/detailsPanelStore'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'

export const ChillToggleButton = ({
  isSouthernHemisphere,
  showMonthsToggle,
}: {
  isSouthernHemisphere: boolean
  showMonthsToggle: boolean
}) => {
  const { data, monthChoosingKeyToUse, selectedMonth } = detailsPanelStore.useSelector((s) => {
    if (isSouthernHemisphere) {
      return {
        monthChoosingKeyToUse: 'chillMarVsMay' as 'chillMarVsMay' | 'chillSepVsNov',
        selectedMonth: s.chillMarVsMay,
        data: [
          { label: translate.dates.monthLabel('MAR'), value: 'MAR' as TChillMarVsMay },
          { label: translate.dates.monthLabel('MAY'), value: 'MAY' as TChillMarVsMay },
        ],
      }
    }

    return {
      monthChoosingKeyToUse: 'chillSepVsNov' as 'chillMarVsMay' | 'chillSepVsNov',
      selectedMonth: s.chillSepVsNov,
      data: [
        { label: translate.dates.monthLabel('SEP'), value: 'SEP' as TChillSepVsNov },
        { label: translate.dates.monthLabel('NOV'), value: 'NOV' as TChillSepVsNov },
      ],
    }
  })

  return showMonthsToggle ? (
    <ToggleButton
      buttonProps={{ size: 'xs', className: css({ fontSize: 13 }) }}
      data={data}
      onChange={(newValue) =>
        detailsPanelStore.setState((s) => ({ ...s, [monthChoosingKeyToUse]: newValue }))
      }
      value={selectedMonth}
    />
  ) : null
}
